import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Request, GET} from 'requests';
import {default as RequestsMixin, IS_DONE} from 'requests/RequestsMixin';
import {Link, browserHistory} from 'react-router';
import NavLink from 'components/NavLink';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import Header from './Header';
import {default as UpgradeModal, MAX_TYPEFACES_PER_KIT, NO_CUSTOM_TYPEFACES_ALLOWED} from '../components/UpgradeModal';
import UploadTypefaceForm from './UploadTypefaceForm';
import {ResourcesMatching, Requesting, Done} from 'requests/components';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const UploadTypefaceController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return this.upgradeModalState(this.props);
  },

  componentDidMount() {
    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      characterSets: new Request({
        method: GET,
        url: ['api', 'character-sets'],
        useCache: false,
      }),
    });

    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      typefaceSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
      }),
    });

    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      }),
    });
  },

  componentWillReceiveProps(nextProps) {
    this.setState(this.upgradeModalState(nextProps));
  },

  transitions(register) {
    register({
      request: this.requests.refreshWorkingSetTypefaces,
      to: IS_DONE,
      call(rm) {
        browserHistory.push(`/kits/${this.props.kitToken}/typefaces`);
      },
    });
  },

  upgradeModalState(props) {
    let showUpgradeModal = (this.state) ? this.state.showUpgradeModal : false;
    let upgradeModalReason = (this.state) ? this.state.upgradeModalReason : null;

    if (!this.canAddCustomTypefaces(props)) {
      showUpgradeModal = true;
      upgradeModalReason = NO_CUSTOM_TYPEFACES_ALLOWED;
    }

    if (!this.canAddTypefacesToKit(props)) {
      showUpgradeModal = true;
      upgradeModalReason = MAX_TYPEFACES_PER_KIT;
    }

    return {showUpgradeModal, upgradeModalReason};
  },

  canAddCustomTypefaces(props) {
    if (!this.requests) {
      return true;
    }

    const rm = this.resourceManager(props || this.props);
    let canAddCustomTypefaces = true;

    if (rm.requests.isDone(this.requests.subscription)) {
      const subscription = rm.type(this.requests.subscription, 'subscriptions').get();

      canAddCustomTypefaces = subscription.customTypefacesAllowed > 0;
    }

    return canAddCustomTypefaces;
  },

  canAddTypefacesToKit(props) {
    if (!this.requests) {
      return true;
    }

    const rm = this.resourceManager(props || this.props);
    let canAddTypefacesToKit = true;

    if (rm.requests.isDone(this.requests.subscription) && rm.requests.isDone(this.requests.workingSetTypefaces)) {
      const subscription = rm.type(this.requests.subscription, 'subscriptions').get();
      const workingSetTypefaces = rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all();

      canAddTypefacesToKit = workingSetTypefaces.size < subscription.workingSetTypefacesAllowed;
    }

    return canAddTypefacesToKit;
  },

  resources() {
    const rm = this.resourceManager();

    return {
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      kit: rm.type(this.requests.kit, 'kits').get(),
      typefaceSettings: rm.type(this.requests.typefaceSettings, 'typeface-settings').get(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all(),
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all(),
    };
  },

  handleRequestToUpgrade() {
    location.assign('/upgrade');
  },

  handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false,
    });
  },

  handleUploadTypefaceClicked() {
    if (!this.canAddCustomTypefaces()) {
      this.setState({
        showUpgradeModal: true,
        upgradeModalReason: NO_CUSTOM_TYPEFACES_ALLOWED,
      });
    }
  },

  renderUploadTypeface() {
    const {subscription, characterSets, typefaceSettings} = this.resources();

    return (
      <div>
        <UpgradeModal
          isOpen={this.state.showUpgradeModal}
          reason={this.state.upgradeModalReason}
          subscription={subscription}
          onOkayClicked={this.handleHideUpgradeModal}
          onUpgradeClicked={this.handleRequestToUpgrade}
          onCloseClicked={this.handleHideUpgradeModal}
        />

        <UploadTypefaceForm
          dispatch={this.props.dispatch}
          kitToken={this.props.kitToken}
          characterSets={characterSets}
          typefaceSettings={typefaceSettings}
          isAllowed={this.canAddCustomTypefaces() && this.canAddTypefacesToKit()}
          onUploadTypefaceClicked={this.handleUploadTypefaceClicked}
        />
      </div>
    );
  },

  renderMain() {
    const {kitToken} = this.props;
    const {kit} = this.resources();

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <Link to={`/kits/${kitToken}/typefaces`} className="link-dashed-none">&lsaquo; Back to {kit.name}</Link>
        <Header heading={'Add Typefaces'} donePath={`/kits/${kitToken}/typefaces`}>
          <NavLink to={`/kits/${kitToken}/typefaces/new`}>All Typefaces</NavLink>
          <NavLink to={`/kits/${kitToken}/typefaces/upload`}>Upload a Typeface</NavLink>
        </Header>
        {this.renderUploadTypeface()}
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    const requests = [
      this.requests.subscription,
      this.requests.kit,
      this.requests.typefaceSettings,
      this.requests.characterSets,
      this.requests.workingSetTypefaces,
    ];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={requests} render={this.renderSpinner} />
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(UploadTypefaceController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/UploadTypefaceController.js